import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnBoardingComponent } from './on-boarding/on-boarding.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AvatarModule } from 'ngx-avatars';
import { DiscoveryHomeComponent } from './discovery-home/discovery-home.component';
import { DiscoveryComponent } from './discovery/discovery.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@app/shared/shared.module';
import { DiscoveryContentSubStepsComponent } from './discovery-content-sub-steps/discovery-content-sub-steps.component';
import { TemplateSetupHomeComponent } from './template-setup-home/template-setup-home.component';
import { LottieComponent } from 'ngx-lottie';
import { TemplateMaintenanceComponent } from './template-maintenance/template-maintenance.component';
import { FilterDiscoveryVaultGroupComponent } from './discovery-super-path/filter-discovery-vault-group/filter-discovery-vault-group.component';
import { VaultSetupHomeComponent } from './vault-setup-home/vault-setup-home.component';
import { RenameTemplateComponent } from './template-setup-home/rename-template/rename-template.component';
import { CreateEntityDiscoveryModalComponent } from './create-entity-discovery-modal/create-entity-discovery-modal.component';
import { MyDataCardComponent } from './my-data-card/my-data-card.component';

@NgModule({
  declarations: [
    OnBoardingComponent,
    DiscoveryHomeComponent,
    DiscoveryComponent,
    DiscoveryContentSubStepsComponent,
    TemplateSetupHomeComponent,
    TemplateMaintenanceComponent,
    FilterDiscoveryVaultGroupComponent,
    VaultSetupHomeComponent,
    RenameTemplateComponent,
    CreateEntityDiscoveryModalComponent,
    MyDataCardComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AvatarModule,
    MatIconModule,
    NgbModule,
    MatMenuModule,
    MatButtonModule,
    LottieComponent,
  ],
  exports: [
    OnBoardingComponent,
    DiscoveryHomeComponent,
    DiscoveryComponent,
    TemplateSetupHomeComponent,
    TemplateMaintenanceComponent,
    FilterDiscoveryVaultGroupComponent,
    VaultSetupHomeComponent,
    CreateEntityDiscoveryModalComponent,
    MyDataCardComponent,
  ],
  providers: [],
})
export class OnBoardingModule {}
